<template>
    <div>
        <div class="alert alert-danger mt-10 mb-30" role="alert"
             v-show="hasErrors()">
            <b>Please correct the following errors:</b>
            <ul>
                <li v-for="error in errors.entries.paid_amount">{{ error }}</li>
                <li v-for="error in errors.global_errors">{{ error }}</li>
            </ul>
        </div>
        <div class="mt-20">
            <table id="due-entries"
                   class="table data-table dataTable table-bordered table-striped table-responsive border-0">
                <thead>
                <tr>
                    <th class="w-40">SL</th>
                    <th>Due For</th>
                    <th>Due Date</th>
                    <th>Amount</th>
                    <th>Payable</th>
                    <th>Paid</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(entry, index) in entries" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ entry.due_for }}</td>
                    <td>{{ entry.due_date }}</td>
                    <td class="item-input">
                        {{ entry.amount }}
                    </td>
                    <td>
                        {{ entry.due_amount }}
                    </td>
                    <td>
                        <input class="form-control unit-cost-input text-right"
                               v-model="entry.paid_amount"
                               v-bind:class="{ 'is-invalid' : errors.entries.paid_amount[index] }"
                               @keyup="calculateTotalAmount"
                        />
                        <small class="invalid-feedback d-block"
                               v-show="errors.entries.paid_amount[index] !== ''">
                          {{ errors.entries.paid_amount[index] || '' }}
                        </small>
                    </td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <th colspan="5" class="text-right font-weight-bolder">Total</th>
                    <th class="text-right pr-20">{{ totalAmount.toFixed(2) }}</th>
                </tr>
                </tfoot>
            </table>

            <button type="submit" class="d-block ladda-button btn btn-primary"
                    data-app-plugin="ladda" data-style="expand-left"
                    @click="submit"
                    >
                Submit
            </button>

        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import FormElement from '../../components/FormElement';
import DatePicker from "../../components/DatePicker";
import moment from "moment";

export default {
    components: {
        DatePicker,
        FormElement
    },
    props: {
        donorId: {
            type: Number,
            required: true
        },
        entries: {
            type: Object,
            required: true
        },
        currencySymbol: {
            type: String,
            required: true
        }
    },
    setup(props) {
        return {
            entries: ref(props.entries.map(entry => ({
                due_id: entry.due_id,
                due_for: entry.due_for,
                due_date: entry.due_date,
                amount: entry.amount,
                due_amount: entry.due_amount,
                paid_amount: Number(entry.due_amount).toFixed(2),
            }))),
            totalAmount: ref(0),
            errors: ref({
                entries: {
                    paid_amount: {},
                },
                global_errors: []
            }),
            csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        moment(date) {
            moment.locale('en')
            return date ? moment(date) : moment()
        },
        calculateTotalAmount() {
            this.totalAmount = 0;
            this.totalAmount = this.entries.reduce((sum, entry) => {
                return sum + parseFloat(entry.paid_amount || 0);
            }, 0);
        },
        submissionData() {
            return {
                entries: this.entries.map(entry => ({
                    due_id: entry.due_id,
                    due_amount: entry.due_amount,
                    paid_amount: entry.paid_amount
                })),
            }
        },
        submit() {
            fetch(route('donations.collections.store', {donor: this.donorId}),
                {
                    method: 'post',
                    headers: new Headers({
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    }),
                    credentials: 'include',  // adds cookie header
                    body: JSON.stringify(this.submissionData())
                }
            ).then(async response => {
                if (response.status === 422) {
                    const json = await response.json()
                    this.showSubmissionErrors(this.transformSubmissionErrors(json.errors))
                    window.Ladda.stopAll()
                } else if (!response.ok) {
                    const error = await response.text()
                    toastr.error(`Failed collecting dues: ${error}`)
                    window.Ladda.stopAll()
                } else if (response.redirected) {
                    window.location.href = response.url
                }
            })
        },
        hasErrors() {
            return Object.entries(this.errors.entries.paid_amount).length > 0
                || this.errors.global_errors.length > 0
        },
        transformSubmissionErrors(serverSideErrors) {
            const errors = {
                entries: {
                    paid_amount: {},
                },
                global_errors: []
            }

            for (let prop in serverSideErrors) {
                if (prop.startsWith('entries')) {
                    const propParts = prop.split('.')
                    errors.entries[propParts[2]][propParts[1]] = serverSideErrors[prop][0]
                } else {
                    errors.global_errors.push(serverSideErrors[prop])
                }
            }

            return errors
        },
        showSubmissionErrors(errors) {
            this.errors = errors
            toastr.error(`Please correct the errors specified.`)
            window.scrollTo({top: 0, behavior: 'smooth'})
        }
    },
    mounted() {
        this.calculateTotalAmount()
    }
}
</script>

<style scoped>
  .table td{
    text-align: center;
    vertical-align: middle !important;
  }
</style>
